import React from 'react';
import classNames from 'classnames';

import './styles.css';

interface UncontrolledCheckboxProps {
  value?: undefined;
  onChange?: (e: any) => void;
  label: string;
  className?: string;
  onBlur?: (e: any) => void;
  name?: string;
  disabled?: boolean;
  defaultChecked: boolean;
}

interface ControlledCheckBoxProps {
  value: boolean;
  onChange?: (e: any) => void;
  label: string;
  className?: string;
  onBlur?: (e: any) => void;
  name?: string;
  disabled?: boolean;
  defaultChecked?: undefined;
}

const CheckBox = ({
  value,
  onChange,
  label,
  className,
  onBlur,
  name,
  defaultChecked,
  disabled
}: ControlledCheckBoxProps | UncontrolledCheckboxProps) => {
  return (
    <div className={classNames('CheckBox', className, {disabled})}>
      <input
        id={name}
        type="checkbox"
        className="checkbox"
        onChange={onChange}
        onBlur={onBlur}
        checked={value}
        defaultChecked={defaultChecked}
        disabled={disabled}
      />
      <label htmlFor={name} className="label">
        {label}
      </label>
    </div>
  );
};

export default CheckBox;
